import '../css/404.css';
import { Link } from 'react-router-dom';
import Menu from './components/Menu';
import { useEffect } from 'react';
import { ValidarSesion } from '../shared/Validaciones';

export default function Pagina404(){

    useEffect(()=>{
        ValidarSesion();
    },[])

    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="mensaje404">
                <div>
                    <div className='py-2 text-center'>
                        <h2>Sin resultados</h2>
                    </div>
                    <div className='py-1 text-center'>
                        <Link to='/guias' className='link-primary'>Volver a inicio</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>);
}